// TESTING ONLY - freezes the Resolve Catch-All and Top-up Credits modals with
// the design's sample data, without calling the credits, results, resolve or
// checkout APIs. Only ever active in `npm run dev` (import.meta.env.DEV is
// false in every build). Set to false once you're done testing.
export const FREEZE_FOR_TESTING = import.meta.env.DEV && false;
